import { FC, Suspense, lazy } from 'react'
import { FullLoader } from '../../../../shared'
import { PatientQuestionnaireEvolutionChartProps } from './PatientQuestionnaireEvolutionChart.model'

const LazyPatientQuestionnaireEvolutionChart = lazy(() =>
  import(/* webpackChunkName: "recharts" */ './PatientQuestionnaireEvolutionChart.component').then(
    ({ PatientQuestionnaireEvolutionChart }) => ({
      default: PatientQuestionnaireEvolutionChart,
    }),
  ),
)

const LazyLoadedPatientQuestionnaireEvolutionChart: FC<PatientQuestionnaireEvolutionChartProps> = (
  props,
) => (
  <Suspense fallback={<FullLoader />}>
    <LazyPatientQuestionnaireEvolutionChart {...props} />
  </Suspense>
)
export { LazyLoadedPatientQuestionnaireEvolutionChart as PatientQuestionnaireEvolutionChart }
